import PropTypes from 'prop-types';

var DateInputsPropTypes = {
  innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })]),
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onDateChange: PropTypes.func,
  onCustomKeyDown: PropTypes.func,
  onError: PropTypes.func,
  format: PropTypes.string,
  showMonth: PropTypes.bool,
  showDay: PropTypes.bool,
  showYear: PropTypes.bool,
  step: PropTypes.number,
  yearMaxRange: PropTypes.number,
  disabled: PropTypes.bool,
  yearMinRange: PropTypes.number,
  time: PropTypes.string,
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export { DateInputsPropTypes };
//# sourceMappingURL=propsTypes.js.map
